import React from 'react';
import { Button } from '@/components/ui/button';

interface DrawerFooterProps {
  isDraftMode: boolean;
  selectedUsersCount: number;
  onAddToDraft: () => void;
}

export const DrawerFooter: React.FC<DrawerFooterProps> = ({
  isDraftMode,
  selectedUsersCount,
  onAddToDraft,
}) => {
  if (!isDraftMode || selectedUsersCount === 0) return null;

  return (
    <div className="p-3 border-t border-border bg-background shrink-0">
      <Button
        className="w-full gap-2"
        onClick={onAddToDraft}
      >
        Legg til {selectedUsersCount} i draft
      </Button>
    </div>
  );
};

